function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "book-open");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Course-details",
  transform: "translate(-550.000000, -327.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-24",
  transform: "translate(-32.000000, 127.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-23",
  transform: "translate(580.000000, 63.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-20",
  transform: "translate(0.000000, 108.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "book-open"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bound",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6855025,18.7082217 C15.9113859,17.8189707 18.682885,17.2495635 22,17 C22,16.9325178 22,13.1012863 22,5.50630526 L22,5.50630526 C22,5.23017604 21.7761292,5.00632908 21.5,5.00632908 C21.4957817,5.00632908 21.4915635,5.00632908 21.4873465,5.00648922 C18.658231,5.07811173 15.8291155,5.74261533 12.9999854,7 C12.9999854,7.04449645 12.9999854,10.79246 12.9999854,18.2438906 L12.9999854,18.2438906 C12.9999854,18.520041 13.2238496,18.7439052 13.5,18.7439052 C13.5635398,18.7439052 13.6264972,18.7317946 13.6855025,18.7082217 Z",
  id: "Combined-Shape",
  fill: "#5ADEF0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3144829,18.7082217 C8.08859955,17.8189707 5.31710038,17.2495635 1.99998542,17 C1.99998542,16.9325178 1.99998542,13.1012863 1.99998542,5.50630526 L1.99998542,5.50630526 C1.99998542,5.23017604 2.22385621,5.00632908 2.49998542,5.00632908 C2.50420375,5.00632908 2.5084219,5.00632908 2.51263888,5.00648922 C5.34175439,5.07811173 8.17086991,5.74261533 11,7 C11,7.04449645 11,10.79246 11,18.2438906 L11,18.2438906 C11,18.520041 10.7761358,18.7439052 10.4999854,18.7439052 C10.4364457,18.7439052 10.3734882,18.7317946 10.3144829,18.7082217 Z",
  id: "Path-41-Copy",
  fill: "#FFFFFF"
}))))))));

var SvgLectures = function SvgLectures(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLectures, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lectures.40f0ee7b.svg";
export { ForwardRef as ReactComponent };